export default "__VITE_ASSET__c32ad799__"